import './NoContent.css';
import user1 from '../../../assets/img/dummy-user-1.jpeg';
import user2 from '../../../assets/img/dummy-user-2.jpeg';

const NoContent = ({ message = "Nothing here yet!" }) => {
  return (
    <section className="creator-feed">
      <div className="creator-feed-container">
        <div className="cards-container">
          {/* Purple Card (Bottom) */}
          <div className="feed-card feed-card-purple">
            <img
              src={user2}
              alt="User Avatar"
              className="card-avatar"
            />
            <div className="card-content">
              <div className="skeleton-line skeleton-w-3-4"></div>
              <div className="skeleton-line skeleton-w-1-2"></div>
            </div>
          </div>

          {/* Green Card (Middle) */}
          <div className="feed-card feed-card-green">
            <img
              src="https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-4.jpg"
              alt="User Avatar"
              className="card-avatar"
            />
            <div className="card-content">
              <div className="skeleton-line skeleton-w-5-6"></div>
              <div className="skeleton-line skeleton-w-2-3"></div>
            </div>
          </div>

          {/* Pink Card (Top) - Empty State */}
          <div className="feed-card feed-card-pink">
            <img
              src={user1}
              alt="User Avatar"
              className="card-avatar"
            />
            <div className="card-content">
              <p className="card-text">{message}</p>
              <div className="skeleton-line skeleton-w-full"></div>
              <div className="skeleton-line skeleton-w-3-4"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NoContent;